module.exports = __webpack_public_path__ + "6772cae630a3efce884f4d6524c2e9ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advisory.png
// module id = 233
// module chunks = 1